import { render, staticRenderFns } from "./index.vue?vue&type=template&id=71fac778&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=71fac778&prod&lang=scss&scoped=true"
import style1 from "./index.vue?vue&type=style&index=1&id=71fac778&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_50f6069bc14464b8bd79aa1c8f71d64f/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71fac778",
  null
  
)

export default component.exports